import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';

import type { ThemeType } from '../../types/theme.type';
import { uniqueId } from '../../utils/operators';

export type SelectableTheme = Exclude<ThemeType, 'ims'>;

@Component({
  selector: 'evc-theme-selector',
  templateUrl: './theme-selector.html',
  styleUrl: './theme-selector.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSelectorComponent {
  protected readonly groupName = uniqueId('theme-selector');

  readonly currentTheme = model.required<ThemeType>();
  readonly lightLabel = input('Light');
  readonly darkLabel = input('Dark');
  readonly autoLabel = input('System');
  readonly availableThemes: SelectableTheme[] = ['light', 'dark', 'auto'];
  readonly labels = computed(() => ({
    light: this.lightLabel(),
    dark: this.darkLabel(),
    auto: this.autoLabel(),
  }));
}
